import { render, staticRenderFns } from "./printer-detail.vue?vue&type=template&id=4a620022&scoped=true&"
import script from "./printer-detail.vue?vue&type=script&lang=js&"
export * from "./printer-detail.vue?vue&type=script&lang=js&"
import style0 from "./printer-detail.vue?vue&type=style&index=0&id=4a620022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a620022",
  null
  
)

export default component.exports